module.exports = __webpack_public_path__ + "assets/img/vtuber-resource.eb3505eb.png";